import { FormatBoldIcon, FormatUnderlinedIcon, ItalIcon, StrikethroughSIcon } from '@medly-components/icons';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { FC } from 'react';

import { IS_APPLE } from 'constants/platform';

import { FormatTextButtonsProps } from './types';

export const FormatListButtons: FC<FormatTextButtonsProps> = ({ isEditable, formatType, activeEditor }) => {
    return (
        <>
            <button
                type="button"
                disabled={!isEditable}
                title={IS_APPLE ? 'Bold (⌘B)' : 'Bold (Ctrl+B)'}
                onClick={() => activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}
                className={`toolbar-item spaced ${formatType.bold ? 'active' : ''}`}
                aria-label={`Format text as bold. Shortcut: ${IS_APPLE ? '⌘B' : 'Ctrl+B'}`}
            >
                <FormatBoldIcon />
            </button>
            <button
                type="button"
                disabled={!isEditable}
                title={IS_APPLE ? 'Italic (⌘I)' : 'Italic (Ctrl+I)'}
                onClick={() => activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}
                className={`toolbar-item spaced ${formatType.italic ? 'active' : ''}`}
                aria-label={`Format text as italics. Shortcut: ${IS_APPLE ? '⌘I' : 'Ctrl+I'}`}
            >
                <ItalIcon />
            </button>
            <button
                type="button"
                disabled={!isEditable}
                title={IS_APPLE ? 'Underline (⌘U)' : 'Underline (Ctrl+U)'}
                onClick={() => activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}
                className={`toolbar-item spaced ${formatType.underline ? 'active' : ''}`}
                aria-label={`Format text to underlined. Shortcut: ${IS_APPLE ? '⌘U' : 'Ctrl+U'}`}
            >
                <FormatUnderlinedIcon />
            </button>
            <button
                type="button"
                disabled={!isEditable}
                title="Strikethrough"
                onClick={() => activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')}
                className={`toolbar-item spaced ${formatType.strikethrough ? 'active' : ''}`}
                aria-label="Format text with a strikethrough"
            >
                <StrikethroughSIcon />
            </button>
        </>
    );
};
